module.exports = __webpack_public_path__ + "static/media/12UNCTAD10.63e0fef1.jpg";